module.exports = __webpack_public_path__ + "static/Vendor-464c7b875054c24bb8b0c181c646ffc9.png";